import { IAppointmentPrices, IPartnershipValidation } from "@/interfaces";
import { Endpoint } from "./NetworkService";
import NetworkService2 from "./NetworkService2";
import { useMainStore } from "@/store";

export default class PartnershipService extends NetworkService2 {
  constructor() {
    super()
  }

  activatePartnership = (partner_code: string) => {
    return this.post({ endpoint: Endpoint.partnership, params: { partner_code } });
  };
  removePartnership = (partnershipId: number | string) => {
    return this.delete({ endpoint: `${Endpoint.partnership}/${partnershipId}` });
  };
  async checkPartnership(psiId: number | string): Promise<IPartnershipValidation> {
    let response: IPartnershipValidation = {
      should_show_warning: false,
      can_have_free_appointment: false,
      message: ''
    }
    const session = useMainStore().session
    const { appointments_per_user, max_session_cost, max_spending_amount, user_limit_period } = session?.partnership.info || {}
    if (!appointments_per_user && !max_session_cost && !max_spending_amount && !user_limit_period) {
      return response
    }
    const res = await this.post({ endpoint: Endpoint.checkPartnership, params: { psychologist_id: psiId } });

    response.should_show_warning = !res.data.can_have_appointment
    response.can_have_free_appointment = res.data.can_have_appointment
    response.message = res.data.message

    return response

  }
  calculatePriceForPartnership = (discount_percentage: number, appointment_price: number): IAppointmentPrices => {
    let appointmentNewPrice = 0
    let benefitValue = 0
    let percentage = discount_percentage ?? 0
    if (percentage < 0 || isNaN(percentage)) {
      percentage = 0
    }
    const discountPercentage = percentage / 100
    const totalDiscount = appointment_price * discountPercentage
    appointmentNewPrice = appointment_price - totalDiscount
    benefitValue = totalDiscount
    const minPrice = Number(process.env.VUE_APP_MINIMUM_APPOINTMENT_PRICE)
    if (appointmentNewPrice < minPrice) {
      appointmentNewPrice = minPrice
      benefitValue = appointment_price - minPrice
    }
    return {
      benefitValue,
      appointmentNewPrice
    }
  }
}
